"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainStorage = void 0;
class DomainStorage {
    constructor({ cacheKey, version }) {
        this.version = version;
        this.cacheKey = cacheKey;
    }
    getItem() {
        try {
            const cachedData = localStorage.getItem(this.cacheKey);
            if (cachedData) {
                const formData = JSON.parse(cachedData);
                if (formData.version === this.version) {
                    return formData.value;
                }
                this.removeItem();
            }
        }
        catch (e) {
            this.removeItem();
        }
        return null;
    }
    removeItem() {
        localStorage.removeItem(this.cacheKey);
    }
    setItem(_, value) {
        const formData = { value, version: this.version };
        localStorage.setItem(this.cacheKey, JSON.stringify(formData));
    }
}
exports.DomainStorage = DomainStorage;
//# sourceMappingURL=domain-storage.js.map